export default {
    namespaced: true,
    state: {
        status: null,
        statusText: null
    },
    getters: {
        getErrorStatus:(state)=>state.status,
        getErrorStatusText:(state)=>state.statusText,
    },
    mutations: {
        setErrors(state, errors) {
            state.status = errors?.status
            state.statusText = errors?.statusText
        },
    }
}